import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-grid-system';
import { prettyMatchUrl, teamHasLink, teamNameLabel, getFootballTeamImagePath } from '../../common/rcs_gaz_mc_core_FE';
import TeamLabel from '../TeamLabel';
import Timing from '../TimeResults/Timing';
import Result from '../TimeResults/Result';
import IconFont from '../../components/shared/IconFont';
import MatchRowScorers from '../../components/MatchRowScorers';
import MatchRowIcon from '../../components/MatchRowIcon';
import BetBar from '../../components/BetBar';
import { MatchRowWrapper, MatchStatsWrapper, BetWrapper } from './styles';
import * as status from '../../constants';
import ConfigManager from '../../common/configManager/configManager';
import { disableLinktoMatch } from '../../utils/linkManagement';

const MatchRowFav = ({
  matchRow, dictionary, isMobile, isFav, competitionId, hasHighlights, betMatch, betType,
}) => {
  const isHomeWinner = () => (Number(matchRow.getIn(['homeTeam', 'score'])) > Number(matchRow.getIn(['awayTeam', 'score'])))
    && matchRow.get('status') !== 'LIVE';
  const isAwayWinner = () => (Number(matchRow.getIn(['homeTeam', 'score'])) < Number(matchRow.getIn(['awayTeam', 'score'])))
    && matchRow.get('status') !== 'LIVE';
  const isLive = () => matchRow.get('status') === 'LIVE';
  const isPreMatch = () => matchRow.get('status') === status.PREMATCH_STATUS;
  const imagesURL = ConfigManager.getFootballTeams('min');

  const awayResPen = (matchRow.getIn(['awayTeam', 'starData', 'shootOuts', 'score'])) ?
    matchRow.getIn(['awayTeam', 'starData', 'shootOuts', 'score']) : 0;
  const homeResPen = (matchRow.getIn(['homeTeam', 'starData', 'shootOuts', 'score'])) ?
    matchRow.getIn(['homeTeam', 'starData', 'shootOuts', 'score']) : 0;


  const classLink = () => {
    const homeCode = matchRow.getIn(['homeTeam', 'teamCode']);
    const awayCode = matchRow.getIn(['awayTeam', 'teamCode']);
    let returnedClass = '';
    if (homeCode && awayCode && homeCode.length < 3 && awayCode.length < 3) {
      returnedClass = 'no-event';
    }
    if (homeCode && awayCode && Number(homeCode[homeCode.length - 1]) && Number(awayCode[awayCode.length - 1])) {
      returnedClass = 'no-event';
    }
    if (!teamHasLink(matchRow.getIn(['homeTeam', 'teamName'])) || !teamHasLink(matchRow.getIn(['awayTeam', 'teamName']))) {
      returnedClass = 'no-event';
    }
    if (disableLinktoMatch(window.matchcenterPage.sportId, window.matchcenterPage.competitionId)) {
      returnedClass = 'no-event';
    }
    return returnedClass;
  };

  const getTeamsName = () => {
    const teamsName = {};
    teamsName.homeTeamId = matchRow.getIn(['homeTeam', 'teamId']);
    teamsName.homeTeam = matchRow.getIn(['homeTeam', 'teamName']);
    teamsName.awayTeamId = matchRow.getIn(['awayTeam', 'teamId']);
    teamsName.awayTeam = matchRow.getIn(['awayTeam', 'teamName']);
    return teamsName;
  };

  const getRoundTripLoser = () => {
    const competitionRoundId = matchRow.get('competitionRoundId');
    const competitionIdAsString = competitionId.toString();
    const isSpecialCup =
        competitionIdAsString === '5' ||
        competitionIdAsString === '6' ||
        (competitionRoundId === 'Semi-Finals' && competitionIdAsString === '259') ||
        competitionIdAsString === '1125';
    if (matchRow.get('firstLegResult') && isSpecialCup) {
      const winnerId =
        matchRow.get('secondLegResult') && matchRow.getIn(['secondLegResult', 'winnerId']);
      const loser =
          winnerId === getTeamsName().homeTeamId ? 'away' : 'home';
      return winnerId ? loser : null;
    } else {
      return null;
    }
  };

  return (
    <MatchRowWrapper
      className={classLink()}
      href={prettyMatchUrl(matchRow.getIn(['homeTeam', 'teamName']), matchRow.getIn(['awayTeam', 'teamName']), matchRow.get('matchId'), 1, competitionId, process.env.REACT_APP_SITE)}
    >
      <Row style={{
        width: '100%', marginRight: '0', marginLeft: '0', alignItems: 'center',
      }}
      >
        <Col md={4.6} xs={4.6} style={{ paddingRight: '0', paddingLeft: '5px', marginTop: isPreMatch() ? '0px' : '-10px' }}>
          <TeamLabel
            label={teamNameLabel(matchRow.getIn(['homeTeam', 'teamName']))}
            color="black"
            image={getFootballTeamImagePath(imagesURL, matchRow.get('homeTeam'))}
            marginLeft={0.4}
            font={isHomeWinner() ? 'narrowMedium' : 'narrowRegular'}
            isLoserCrossed={getRoundTripLoser() === 'home'}
          />
        </Col>
        <Col
          md={2}
          xs={2}
          style={{
              paddingRight: '0',
              paddingLeft: '0',
              overflow: 'visible',
            }}
        >
          {matchRow.get('status') !== status.PREMATCH_STATUS &&
            <Result
              awayRes={matchRow.getIn(['awayTeam', 'score'])}
              homeRes={matchRow.getIn(['homeTeam', 'score'])}
              awayPenRes={awayResPen}
              homePenRes={homeResPen}
              status={matchRow.get('status')}
              isMobile={isMobile}
              isFav={isFav}
            />
          }
          <Timing
            timing={matchRow.get('timing')}
            resultType={matchRow.get('resultType')}
            date={matchRow.get('utcDate')}
            isLive={isLive()}
            dictionary={dictionary.competitionTable}
          />
        </Col>
        <Col md={4.6} xs={4.6} style={{ paddingRight: '0', paddingLeft: '5px', marginTop: isPreMatch() ? '0px' : '-10px' }}>
          <TeamLabel
            label={teamNameLabel(matchRow.getIn(['awayTeam', 'teamName']))}
            color="black"
            image={getFootballTeamImagePath(imagesURL, matchRow.get('awayTeam'))}
            marginLeft={0.4}
            font={isAwayWinner() ? 'narrowMedium' : 'narrowRegular'}
            isLoserCrossed={getRoundTripLoser() === 'away'}
          />
        </Col>
        <Col
          lg={0.8}
          md={0.8}
          sm={0.8}
          xs={0.8}
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            flexDirection: 'row',
            paddingRight: '5px',
            paddingLeft: '0',
            marginTop: isMobile ? isPreMatch() ? '0px' : '-10px' : '0px',
          }}
        >
          <IconFont
            className="icon-matchcenter-right-arrow"
            color="linkColor"
            font={16}
            weight="bold"
            withCursor
          />
        </Col>
      </Row>
      {matchRow && (
        matchRow.getIn(['homeTeam', 'starData', 'goals']).size > 0 ||
        matchRow.getIn(['starData', 'substitutions']) > 0 ||
        matchRow.getIn(['starData', 'yellowBookings']) > 0 ||
        matchRow.getIn(['starData', 'redBookings']) > 0
        || matchRow.getIn(['awayTeam', 'starData', 'goals']).size > 0
      ) &&
      <Row
        className="isAnHighlights"
        style={{
        width: '100%',
        marginRight: '0',
        marginLeft: '0',
        display: !hasHighlights ? 'none' : 'flex',
      }}
      >
        <Col md={4.05} sm={4.05} xs={3.95} style={{ padding: '0' }} offset={{ md: 1.2, sm: 1.2, xs: 1.2 }}>
          <MatchRowScorers
            color="gray"
            weight="normal"
            size={0.8}
            scorers={matchRow.getIn(['homeTeam', 'starData', 'goals'])}
            font="narrowRegular"
          />
          {matchRow.getIn(['homeTeam', 'starData', 'shootOuts']) && matchRow.getIn(['homeTeam', 'starData', 'shootOuts', 'penalties']) &&
          <MatchRowScorers
            color="gray"
            weight="normal"
            size={1.5}
            penaltyScorers={matchRow.getIn(['homeTeam', 'starData', 'shootOuts', 'penalties'])}
            font="narrowRegular"
          />
          }
        </Col>
        <Col
          md={1.4}
          sm={1.4}
          xs={1.6}
          style={{
            display: 'flex', justifyContent: 'center', padding: '0', alignItems: 'flex-end',
          }}
        />
        <Col md={4.05} sm={4.05} xs={3.95} style={{ padding: '0' }} offset={{ md: 0.4, sm: 0.4, xs: 0.4 }}>
          <MatchRowScorers
            color="gray"
            weight="normal"
            size={0.8}
            scorers={matchRow.getIn(['awayTeam', 'starData', 'goals'])}
            font="narrowRegular"
          />
          {matchRow.getIn(['awayTeam', 'starData', 'shootOuts']) && matchRow.getIn(['awayTeam', 'starData', 'shootOuts', 'penalties']) &&
          <MatchRowScorers
            color="gray"
            weight="normal"
            size={1.5}
            penaltyScorers={matchRow.getIn(['awayTeam', 'starData', 'shootOuts', 'penalties'])}
            font="narrowRegular"
          />
          }
        </Col>
      </Row>
      }
      {hasHighlights && matchRow && (
        matchRow.getIn(['starData', 'substitutions']) > 0 || matchRow.getIn(['starData', 'yellowBookings']) > 0 || matchRow.getIn(['starData', 'redBookings']) > 0) &&
        <Row style={{
          width: '100%', marginRight: '0', marginLeft: '9px', marginTop: '10px',
        }}
        >
          <Col
            md={12}
            sm={12}
            xs={12}
            style={{
              display: 'flex', justifyContent: 'center', padding: '0', alignItems: 'flex-end',
            }}
          >
            {matchRow && matchRow.get('status') !== 'WALKOVER' &&
            <MatchStatsWrapper isFav={isFav}>
              {matchRow && matchRow.getIn(['starData', 'substitutions']) > 0 &&
              <MatchRowIcon
                matchStats={matchRow.getIn(['starData', 'substitutions'])}
                color="black"
                bg="green"
                size={13}
                className="icon-matchcenter-arrows-circle"
                marginRight={0.2}
                marginLeft={isFav ? 0 : 1}
                font="narrowMedium"
                isSubstitution
              >
                <span className="path1" />
                <span className="path2" />
              </MatchRowIcon>
              }
              {matchRow && matchRow.getIn(['starData', 'redBookings']) > 0 &&
              <MatchRowIcon
                matchStats={matchRow.getIn(['starData', 'redBookings'])}
                color="white"
                bg="red"
                size={13}
                className="icon-matchcenter-rectangle"
                font="narrowMedium"
              />
              }
              {matchRow && matchRow.getIn(['starData', 'yellowBookings']) > 0 &&
              <MatchRowIcon
                matchStats={matchRow.getIn(['starData', 'yellowBookings'])}
                color="black"
                bg="yellow"
                size={13}
                className="icon-matchcenter-rectangle"
                font="narrowMedium"
              />
              }
            </MatchStatsWrapper>
            }
          </Col>
        </Row>
      }
      {/*{matchRow.get('status') !== 'FULL' && betMatch && betMatch.odds && betType !== 0 && process.env.REACT_APP_SITE !== 'corriere' &&
        <BetWrapper>
          {betMatch.odds && betMatch.odds.filter(obj => obj.idMatch === `${matchRow.getIn(['homeTeam', 'teamId'])} - ${matchRow.getIn(['awayTeam', 'teamId'])}`).length > 0 &&
          <BetBar
            isMobile={isMobile}
            betType={betType}
            betData={betMatch.odds.filter(obj => obj.idMatch === `${matchRow.getIn(['homeTeam', 'teamId'])} - ${matchRow.getIn(['awayTeam', 'teamId'])}`)}
            competitionId={window.matchcenterPage.competitionId}
          />
          }
        </BetWrapper>
        }*/}
      {matchRow.status !== 'FULL' && betMatch && betMatch.odds && betType !== 0 && betType !== '4' && process.env.REACT_APP_SITE !== 'corriere' &&
        <BetWrapper>
          {betMatch.odds && betMatch.odds.filter(obj => obj.idMatch === `${matchRow.getIn(['homeTeam', 'teamId'])} - ${matchRow.getIn(['awayTeam', 'teamId'])}`).length > 0 &&
          <BetBar
            isMobile={isMobile}
            betType={betType}
            betData={betMatch.odds.filter(obj => obj.idMatch === `${matchRow.getIn(['homeTeam', 'teamId'])} - ${matchRow.getIn(['awayTeam', 'teamId'])}`)}
            competitionId={window.matchcenterPage.competitionId}
          />
          }
        </BetWrapper>
      }
      {matchRow.status === 'PREMATCH' && betMatch && betMatch.odds && betType !== 0 && betType === '4' && process.env.REACT_APP_SITE !== 'corriere' &&
      <BetWrapper>
        {betMatch.odds && betMatch.odds.filter(obj => obj.idMatch === `${matchRow.getIn(['homeTeam', 'teamId'])} - ${matchRow.getIn(['awayTeam', 'teamId'])}`).length > 0 &&
        <BetBar
          isMobile={isMobile}
          betType={betType}
          betData={betMatch.odds.filter(obj => obj.idMatch === `${matchRow.getIn(['homeTeam', 'teamId'])} - ${matchRow.getIn(['awayTeam', 'teamId'])}`)}
          competitionId={window.matchcenterPage.competitionId}
        />
        }
      </BetWrapper>
      }
    </MatchRowWrapper>
  );
};

MatchRowFav.propTypes = {
  hasHighlights: PropTypes.bool,
  matchRow: PropTypes.any,
  //actions: PropTypes.any,
  dictionary: PropTypes.any,
  isMobile: PropTypes.bool,
  isFav: PropTypes.bool,
  //date: PropTypes.string,
  //sportId: PropTypes.any,
  competitionId: PropTypes.any,
  betMatch: PropTypes.any,
  betType: PropTypes.any,
};

export default MatchRowFav;



// WEBPACK FOOTER //
// ./src/components/MatchRowFav/index.js